import { render, staticRenderFns } from "./deployCaseDialog.vue?vue&type=template&id=bb7b8c96&scoped=true&"
import script from "./deployCaseDialog.vue?vue&type=script&lang=js&"
export * from "./deployCaseDialog.vue?vue&type=script&lang=js&"
import style0 from "./deployCaseDialog.vue?vue&type=style&index=0&id=bb7b8c96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7b8c96",
  null
  
)

export default component.exports